import * as yup from 'common/yup';
import {CommonReportParams} from 'types/diplomat/reports/CommonReportParams';
import {DiplomatObject} from 'types/DiplomatObject';

export const UserActivityReportParameters = yup
   .object({
      byObjectId: yup.boolean(),
      byObjectType: yup.boolean(),
      byUserId: yup.boolean(),
      byUserIp: yup.boolean(),
      includeArchive: yup.boolean(),
      objectId: yup.string(),
      objectType: yup.string().when(['allRecords', 'byObjectType'], {
         is: (allRecords, byObjectType) => !allRecords && byObjectType,
         then: DiplomatObject.fields.objectType,
      }),
      userId: yup.string(),
      userIp: yup.string(),
   })
   .concat(CommonReportParams);

export type IUserActivityReportParameters = yup.InferType<typeof UserActivityReportParameters>;
